import { Subject } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var HeaderService = /** @class */ (function () {
    function HeaderService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.headerMenu = new Subject();
        this.headerMenuChanged$ = this.headerMenu.asObservable();
        this.selectedMenu = new Subject();
        this.selectedMenuChanged$ = this.selectedMenu.asObservable();
        this.isSessionAlive = new Subject();
        this.isSessionAliveChanged$ = this.isSessionAlive.asObservable();
        this.serviceUrl = this.env.servicePath;
    }
    HeaderService.prototype.setCurrentUserDateTime = function (date) {
        this.currentDateTime = date;
    };
    HeaderService.prototype.getCurrentUserDateTime = function () {
        return this.currentDateTime;
    };
    HeaderService.prototype.displayMenu = function (display) {
        this.headerMenu.next(display);
    };
    HeaderService.prototype.setSelectedMenu = function (menuCommand) {
        this.selectedMenu.next(menuCommand);
    };
    HeaderService.prototype.setSessionAlive = function (session) {
        this.isSessionAlive.next(session);
    };
    HeaderService.prototype.createHeaderCard = function () {
        var path = this.serviceUrl + "CreateHeaderCard";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    HeaderService.prototype.getHeaderMenuItems = function (id) {
        var path = this.serviceUrl + "GetHeaderCardMenuActions/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.selectHeaderMenuItems = function (id, command) {
        var path = this.serviceUrl + "SelectHeaderCardMenuAction/" + id + "/" + command;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.getTimeZoneList = function () {
        var path = this.serviceUrl + "GetTimeZoneList";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.setTimeZone = function (timeZoneId) {
        var path = this.serviceUrl + "ChangeUserTimeZone/" + timeZoneId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.getTime = function () {
        var path = this.serviceUrl + "GetTime";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.updateProfile = function () {
        var path = this.serviceUrl + "UpdateProfile";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.changePassword = function () {
        var path = this.serviceUrl + "ChangePassword";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.getLatestNotificationDate = function () {
        var path = this.serviceUrl + "GetLatestNotificationDate";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.notificationsNextPage = function () {
        var path = this.serviceUrl + "NotificationsNextPage";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.getNotifications = function () {
        var path = this.serviceUrl + "GetNotifications";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.markNotificationsRead = function () {
        var path = this.serviceUrl + "MarkNotificationsAsRead";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.MarkOneNotificationAsRead = function (notificationId) {
        var path = this.serviceUrl + "MarkOneNotificationAsRead/" + notificationId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.getUnreadCount = function () {
        var path = this.serviceUrl + "GetCurrentUnread";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.selectNotification = function (id) {
        var path = this.serviceUrl + "SelectNotification/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.performOneTimeAction = function (userId, key) {
        var path = this.serviceUrl + "OneTimeAction/" + userId + "/" + key;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true' })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.loginAndAction = function (userId, actionName, data) {
        var path = this.serviceUrl + "LoginAndAction/" + userId + "/" + actionName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
        };
        return this.http.post("" + path, data, httpOptions);
    };
    HeaderService.prototype.actionAndNavigate = function (id, data) {
        var path = this.serviceUrl + "ActionAndNavigate?actionKey=" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
        };
        return this.http.post("" + path, data, httpOptions);
    };
    HeaderService.prototype.actionAndNavigateNew = function (path, userId, action, data) {
        var path = this.serviceUrl + "ActionAndNavigate/" + path + "?userId=" + userId + "&actionKey=" + action;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
        };
        return this.http.post("" + path, data, httpOptions);
    };
    HeaderService.prototype.endSession = function () {
        var path = this.serviceUrl + "EndSession";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.getUserCommunities = function () {
        var path = this.serviceUrl + "GetUserCommunities";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.changeCommunity = function (communityId) {
        var path = this.serviceUrl + "ChangeCommunity/" + communityId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.createMenuCard = function (group) {
        var path = this.serviceUrl + "CreateMenuCard/" + group;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.getMenuCardMenuActions = function (id) {
        var path = this.serviceUrl + "GetMenuCardMenuActions/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.selectMenuCardMenuAction = function (id, actionName) {
        var path = this.serviceUrl + "SelectMenuCardMenuAction/" + id + "/" + actionName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.keepSessionAlive = function () {
        var path = this.serviceUrl + "KeepSessionAlive";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.validateKey = function (userId, oneTimeKey) {
        var path = this.serviceUrl + "ValidateKey?SessionKey=" + oneTimeKey + "&UserId=" + userId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.createLanguageCard = function () {
        var path = this.serviceUrl + "CreateLanguageCard";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.getLanguages = function (id) {
        var path = this.serviceUrl + "GetLanguages/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    HeaderService.prototype.selectLanguage = function (id, locale) {
        var path = this.serviceUrl + "SelectLanguage/" + id + "/" + locale;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    HeaderService.prototype.getPageTour = function (pageName) {
        var path = this.serviceUrl + "GetPageTour";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, pageName, httpOptions);
    };
    HeaderService.ngInjectableDef = i0.defineInjectable({ factory: function HeaderService_Factory() { return new HeaderService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: HeaderService, providedIn: "root" });
    return HeaderService;
}());
export { HeaderService };
